import type { FormStepId, RequestFieldDefinition } from './types';

/** Compact header label — matches `subsectionFieldsFromSummaryRows` truncation. */
export function shortLabelFromLabel(label: string): string {
  return label.length > 22 ? `${label.slice(0, 19)}…` : label;
}

export function defineField(
  stepId: FormStepId,
  subsectionId: string,
  order: number,
  dataField: string,
  label: string,
  shortLabel?: string,
  surfaces: RequestFieldDefinition['surfaces'] = { step: true, summary: true },
): RequestFieldDefinition {
  return {
    dataField,
    stepId,
    subsectionId,
    order,
    label,
    shortLabel: shortLabel ?? shortLabelFromLabel(label),
    surfaces,
  };
}

/** Build registry rows from legacy summary definition shape (migration helper). */
export function fieldsFromSummaryShape<
  T extends { dataField: string; label: string; subsection?: string },
>(
  stepId: FormStepId,
  rows: readonly T[],
  shortLabelOverrides?: Readonly<Record<string, string>>,
): RequestFieldDefinition[] {
  let currentSubsection = 'default';
  const orderBySubsection = new Map<string, number>();
  return rows.map((row) => {
    if (row.subsection != null) {
      currentSubsection = row.subsection;
    }
    const order = orderBySubsection.get(currentSubsection) ?? 0;
    orderBySubsection.set(currentSubsection, order + 1);
    return defineField(
      stepId,
      currentSubsection,
      order,
      row.dataField,
      row.label,
      shortLabelOverrides?.[row.dataField],
    );
  });
}
